module.exports = __webpack_public_path__ + "static/media/lostowice.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lostowice.png
// module id = 876
// module chunks = 0